import React from 'react';
import { Filter, X } from 'lucide-react';

const SELECT_CLS = 'bg-ink-900 border border-ink-600 rounded-md px-2 py-1 text-[11px] text-slate-200 focus:outline-none focus:border-accent';

export function FilterSelect({ label, value, options, onChange, testId }) {
  return (
    <label className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider text-slate-500">
      {label}
      <select value={value} onChange={(e) => onChange(e.target.value)} className={SELECT_CLS} data-testid={testId}>
        {options.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
      </select>
    </label>
  );
}

/** Barre de filtres générique (Équipe / Recrutement). Libellés fournis via t(). */
export default function HRFilterBar({ t, children, shown, total, active, onReset, testId }) {
  return (
    <div className="bg-ink-800 rounded-lg border border-ink-600 px-3 py-2 flex items-center gap-3 flex-wrap" data-testid={testId}>
      <span className="flex items-center gap-1 text-[10px] uppercase tracking-wider text-slate-400 font-bold"><Filter className="w-3.5 h-3.5" /> {t('hr_filter_title')}</span>
      {children}
      <span className="ml-auto text-[11px] text-slate-500" data-testid={`${testId}-count`}>{t('hr_filter_shown', { shown, total })}</span>
      {active && (
        <button type="button" onClick={onReset} className="inline-flex items-center gap-1 text-[11px] text-accent hover:underline" data-testid={`${testId}-reset`}>
          <X className="w-3 h-3" /> {t('hr_filter_reset')}
        </button>
      )}
    </div>
  );
}
